module.exports = __webpack_public_path__ + "static/media/shipment_circle.fca33ab4.svg";